// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__w89fL","card":"styles_card__jXj1M","pulse":"styles_pulse__W65Cs","jump":"styles_jump__5VAlx"};